import React from 'react'
import { Icon } from 'semantic-ui-react'
import { Category, Field } from '~/api/services/loginPopups'
import { ICountry } from '~/api/services/auth'
import { categoryIcons } from './constants'
import InfoPopup from '~/components/InfoPopup'

export const LabelWithInfo: React.FC<{ label: React.ReactNode; info?: string; required?: boolean }> = ({ label, info, required }) => {
  const asterisk = required ? <span style={{ color: 'red' }}>*</span> : null

  if (!info) return <>{label}{asterisk}</>

  return <span style={{ display: 'inline-flex', alignItems: 'baseline', gap: 4 }}>
    {label}
    <InfoPopup content={info} position='top center' styleIcon={{ fontSize: '1.1em', cursor: 'pointer', color: 'grey' }} />
    {asterisk}
  </span>
}

export function getNestedValue(popupField: Field, obj: any, path: string): any {
  if (popupField.action === 3) {
    return ''
  }
  
  const segments = path
    .replace(/\[(\w+)\]/g, '.$1')
    .split('.')
    .filter(Boolean)

  return segments.reduce((acc, key) => acc?.[key], obj)
}

export function chunkArray<T>(arr: T[], size: number): T[][] {
  const result: T[][] = []
  for (let i = 0; i < arr.length; i += size) {
    result.push(arr.slice(i, i + size))
  }
  return result
}

export function renderCategoryIcon(category: Category) {
  return <Icon className={categoryIcons[category]} />
}

export function readOnlyFieldValue(value, value2, slug?: string, countries?: ICountry[]){

  if (slug === 'country') {
    const country = countries.find(c => c.id === Number(value))
    return <>{country?.label || '-'}</>
  }

  if (slug === 'canton') {
    const swissCountry = countries.find(c => c.iso === 'ch')
    const canton = swissCountry?.cantons?.find(ct => ct.id === Number(value))
    return <>{canton?.label || '-'}</>
  }
 
  if (value == null || value === '') {
    return <>-</>
  }

  return <>{`${value} ${value2 ? ` - ${value2}` : ''}`}</>
}
